import script from "./OptionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionCard.vue?vue&type=script&setup=true&lang=ts"

import "./OptionCard.vue?vue&type=style&index=0&id=ca480fb8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca480fb8"]])

export default __exports__